// extracted by mini-css-extract-plugin
module.exports = {"root":"switch_root__lofT4","disabled":"switch_disabled__ioIMd","label":"switch_label___7d9j","switch":"switch_switch__2V3_f","input":"switch_input__D_fSj"};